import React from 'react';
import Alert from 'alerts/account_alerts/Alert';

class AlertList extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let alerts = this.props.alerts.map((alert) => {
      let section = capitalize(alert.alert_type.toLowerCase())
      if (section == "Seo") {
        section = "SEO";
      }
      let shouldRender = false;
      if (section == "SEO" && this.props.userSubscriptions.showSeo) {
        shouldRender = true;
      } else if (section == "Search" && this.props.userSubscriptions.showSearch) {
        shouldRender = true;
      } else if (section == "Social" && this.props.userSubscriptions.showSocial) {
        shouldRender = true;
      } else if (section == "Display" && this.props.userSubscriptions.showDisplay) {
        shouldRender = true;
      } else if (section == "Video" && this.props.userSubscriptions.showVideo) {
        shouldRender = true;
      }

      if (shouldRender == true) {
        return (
          <Alert key={alert.id} alert={alert} resolveAlert={this.props.resolveAlert} snoozeAlert={this.props.snoozeAlert} />
        )
      }
    });

    return (
      <>
        {alerts.length > 0 ?
          <div className="table-responsive">
            <table className="table account-alerts-table mb-0">
              <tbody>
                {alerts}
              </tbody>
            </table>
          </div>
        :
          <div style={{padding: "15px"}}>
            No alerts for this time period
          </div>
        }
      </>
    )
  }
}

export default AlertList;
